import { render, staticRenderFns } from "./currencyValue.vue?vue&type=template&id=41b992df&"
import script from "./currencyValue.vue?vue&type=script&lang=js&"
export * from "./currencyValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports